import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'chat-trigger',
  name: 'Chat Trigger',
  category: 'triggers',
  description: 'Trigger workflows from chat messages and maintain conversation context',
  icon: 'MessageSquare',
  color: 'green',
  version: '2.0.0',
  
  group: ['trigger'],
  
  defaults: {
    name: 'Chat Trigger',
    color: 'green'
  },
  
  subtitle: '{{ $parameter.mode === "hostedChat" ? "Hosted Chat" : "Embedded Chat" }}',
  
  inputs: [],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main'
    }
  ],
  
  tags: ['chat', 'trigger', 'conversation', 'ai', 'messaging'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'Chat Trigger receives messages from users and triggers AI workflows with conversation context'
  }
};

export default definition;
